// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"60":"defc4112","196":"77b2a425","443":"8713e019","624":"b935964e"}[chunkId] + ".css";
};